import PropTypes from 'prop-types';

const ScoreCircle = ({ score, size = 64 }) => {
  const numericScore = Number(score);

  const stroke = 3;
  const normalizedRadius = size / 2 - stroke;
  const circumference = 2 * Math.PI * normalizedRadius;

  const fillPercent = (numericScore + 100) / 200;
  const strokeDashoffset = circumference - fillPercent * circumference;

  // Determine color based on score
  const getScoreColor = value => {
    if (value > 40) {
      return '#22C14D';
    }
    if (value >= 0) {
      return '#FDC700';
    }

    return '#EF2A35';
  };

  const scoreColor = getScoreColor(numericScore);

  return (
    <div className="relative flex-shrink-0" style={{ width: size, height: size }}>
      <svg
        height={size}
        width={size}
        className="absolute top-0 left-0"
        style={{ transform: 'rotate(-90deg)' }}
      >
        {/* Background circle */}
        <circle
          r={normalizedRadius}
          cx={size / 2}
          cy={size / 2}
          stroke="#F1F2F5"
          strokeWidth={stroke}
          fill="none"
        />
        {/* Progress circle */}
        <circle
          r={normalizedRadius}
          cx={size / 2}
          cy={size / 2}
          stroke={scoreColor}
          strokeWidth={stroke}
          fill="none"
          strokeLinecap="round"
          style={{
            strokeDasharray: `${circumference} ${circumference}`,
            strokeDashoffset,
            transition: 'stroke-dashoffset 0.35s ease-in-out',
          }}
        />
      </svg>
      {/* Score text */}
      <div className="absolute inset-0 flex flex-col items-center justify-center font-normal text-[#121723]">
        <span className="leading-none" style={{ fontSize: '1.2rem', marginTop: '6px' }}>
          {score}
        </span>
        <span className="font-normal text-[11px] leading-4 text-center text-[#8F97A5]">
          NPS
        </span>
      </div>
    </div>
  );
};

ScoreCircle.propTypes = {
  score: PropTypes.string.isRequired,
  size: PropTypes.number,
};

export default ScoreCircle;
